<script setup>
// An initials circle for a person. The same avatar pattern was previously
// duplicated per-caller (UserFooter, UserMenu, ProfileIdentityCard); this is
// the shared version — pass a name and it derives the initials.
import { computed } from 'vue'

const props = defineProps({
	name: { type: String, required: true },
	size: { type: Number, default: 34 },
})

const initials = computed(() =>
{
	const parts = props.name.trim().split(/\s+/).filter(Boolean);
	if (parts.length == 0) return '';
	if (parts.length == 1) return parts[0].charAt(0).toUpperCase();
	return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
})
</script>


<template>
	<div class="l-avatar" :style="{ width: size + 'px', height: size + 'px', fontSize: (size * 0.4) + 'px' }" aria-hidden="true">
		<span class="initials">{{ initials }}</span>
	</div>
</template>


<style scoped>
.l-avatar
{
	border-radius: 50%;
	background: var(--brand);
	color: var(--brand-on);
	font-weight: 600;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: var(--font-display);
	flex: none;
}

.initials
{
	padding-top: 0.1em;
}
</style>
